import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

import { ref, watch, nextTick, computed } from 'vue'
import { DATA_TYPE } from '@/common'


export default /*#__PURE__*/_defineComponent({
  __name: 'input-params',
  props: ['otherProps', 'code'],
  emits: ['on-change'],
  setup(__props, { emit: $emit }) {

const props: any = __props;





// 处理转换一下其他参数
const formaterOtherParams = () => {
  return {
    ...props.otherProps,
    maxlength: props.otherProps?.maxLen,
  }
}

const getDataType = () => {
  return props.otherProps?.type
}

const getDataRange = () => {
  return props.otherProps?.range || []
}

const change = (value: any) => {
  $emit('on-change', {
    code: props.code,
    value,
  })
}

// const dataType = props.otherProps.dataType
// console.log(dataType, 'dataTypedataType')

const input = ref(undefined)

return (_ctx: any,_cache: any) => {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (getDataType() === _unref(DATA_TYPE).INT)
    ? (_openBlock(), _createBlock(_component_el_input_number, _mergeProps({
        key: 0,
        class: "ws_left",
        modelValue: input.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input).value = $event))
      }, { ...props.otherProps }, {
        controls: false,
        onChange: change,
        style: {"width":"100%"}
      }), null, 16, ["modelValue"]))
    : (getDataType() === _unref(DATA_TYPE).ENUM)
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 1,
          onChange: change,
          modelValue: input.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((input).value = $event)),
          class: "ws_left"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDataRange(), (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item,
                label: item,
                value: item
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : (_openBlock(), _createBlock(_component_el_input, _mergeProps({
          key: 2,
          modelValue: input.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((input).value = $event))
        }, { ...formaterOtherParams() }, { onChange: change }), null, 16, ["modelValue"]))
}
}

})